import { VotesModel } from './votes.model';

export class PropertyVotesModel {
  [property: string]: VotesModel;
}
